import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { BodyText, Size as BodyTextSize } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { ClockIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ClockIcon'
import { Link } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/link/Link'
import { InlineBanner } from '@lyrahealth-inc/ui-core-crossplatform/src/molecules/inlineBanner/InlineBanner'
import { openUrl } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/expo-linking'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

import { NP_TEST_PLAN_SUPPORT_EMAIL } from '../npTestPlanConstants'

export interface NpTestPlanWaitingBannerProps {
  title: string
  description: string
  /** Unprefixed; `tID` is applied here. */
  testIdName: string
}

export const NpTestPlanWaitingBanner: FunctionComponent<NpTestPlanWaitingBannerProps> = ({
  title,
  description,
  testIdName,
}) => {
  const { colors } = useTheme() as ThemeType

  return (
    <InlineBanner
      testId={tID(testIdName)}
      backgroundColor={colors.backgroundSection}
      borderRadius='8px'
      padding='16px'
      iconMarginRight={8}
      icon={<ClockIcon size={24} fillColor={colors.iconDefault} />}
      title={<BodyText text={title} size={BodyTextSize.LARGE} color={colors.textPrimary} bold />}
      text={
        <BodyText
          size={BodyTextSize.DEFAULT}
          color={colors.textSecondary}
          text={
            <FormattedMessage
              defaultMessage='{description} Contact <link>{supportEmail}</link> if you need additional support.'
              description='Body of the callout explaining why a neuropsych test plan section is not available yet'
              values={{
                description,
                supportEmail: NP_TEST_PLAN_SUPPORT_EMAIL,
                link: (chunks: React.ReactNode) => (
                  <Link
                    testID={tID(`${testIdName}-supportEmail`)}
                    text={chunks}
                    size={BodyTextSize.DEFAULT}
                    onPress={() => openUrl(`mailto:${NP_TEST_PLAN_SUPPORT_EMAIL}`)}
                  />
                ),
              }}
            />
          }
        />
      }
    />
  )
}
